module.exports = __webpack_public_path__ + "static/media/fail-buzzer-04.a264f088.mp3";